import { put, takeEvery, all, fork } from 'redux-saga/effects';
import * as constants from '../constants/all';
import * as loginSaga from './loginSagas';
import * as mainMenuSaga from './mainMenuSagas';
import * as coursePageSaga from './coursePageSagas';
import * as loginAnnouncementSaga from './loginAnnoucementSagas';
import * as messagesSagas from './messagesSagas';
import * as assignmentSaga from './assignmentSagas';
import * as storageManagementSagas from './storageManagementSagas';
import * as iFrameSagas from './iFrameSagas';
import * as announcementSaga from './announcementSagas';
import * as documentSagas from './documentSagas';
import * as elessonSagas from './elessonSagas';
import * as virtualClassSagas from './virtualClassSagas';
import * as linkSagas from './linkSagas';
import * as enrollmentSagas from './enrollmentSagas';
import * as requestSagas from './requestSagas';
import * as profileSagas from './profileSagas';
import * as translationsSagas from './translationsSagas';
import * as learningOutcomesSagas from './learningOutcomesSagas';
import * as madlenIntegrationSagas from './madlenIntegrationSagas';
import * as videoSagas from './videoSagas';
import * as forumSagas from './forumSagas';
import * as projectSagas from './projectSagas';
import * as reportSagas from './reportSagas';
import * as backgroundSagas from './backgroundSagas';
import * as notificationSagas from './notificationSagas';
import * as examSagas from './examSagas';
import * as examSessionSagas from './examSessionSagas';
import * as calendarSagas from './calendarSagas';
import * as questionSagas from './questionSagas';
import * as qrPollingSagas from './qrPollingSagas';
import * as ltiSagas from './ltiSagas';
import * as surveySagas from './surveySagas';
import * as activityCopySagas from './activityCopySagas';
import * as activityMultiplySagas from './activityMultiplySagas';
import * as HelpdeskSagas from './helpdeskSaga';
import * as userHomeSagas from './userHomeSagas';
import * as informationNoteSagas from './informationNoteSagas';
import * as gradebookSagas from './gradebookSagas';
import * as myFilesSagas from './filesSagas';

import { Log } from 'ng2-logger';

const _logger = Log.create('Sagas');

function* helloSaga() {
    yield;
}

export default function* rootSaga() {
    yield all([
        fork(helloSaga),

        fork(loginSaga.watchGetLoginPageData),
        fork(loginSaga.watchClickLoginForm),
        fork(loginSaga.watchMyForgotPassword),
        fork(loginSaga.watchMyForgotPasswordQuestionAnswer),
        fork(loginSaga.watchMyForgotCheckToken),
        fork(loginSaga.watchMyForgotSave),
        fork(loginSaga.watchgetUserIdentity),
        fork(loginSaga.watchLoginExternal),
        fork(loginSaga.watchLoginExternalObs),
        fork(loginSaga.watchLoginEdevlet),
        fork(loginSaga.watchLoginToAlms),
        fork(loginSaga.watchLoginToExamApp),
        fork(loginSaga.watchLogOutFromAlms),
        fork(loginSaga.wathCheckVerificationCode),
        fork(loginSaga.watchVerificateUser),

        fork(requestSagas.watchRequestRefreshToken),

        fork(enrollmentSagas.watchGetEnrollmentData),
        fork(enrollmentSagas.watchaddEnrollmentActionLog),
        fork(enrollmentSagas.watchGetMyGrades),
        fork(enrollmentSagas.watchGetRefreshMyEnrollments),

        fork(mainMenuSaga.watchGetMainMenuData),
        fork(mainMenuSaga.watchGetMainMenuCourseTabData),
        fork(mainMenuSaga.watchGetMainMenuCourseContentData),

        fork(coursePageSaga.watchGetCoursePageData),
        fork(coursePageSaga.watchGetCoursePageHeaderInfoData),
        fork(coursePageSaga.watchGetClassActivityProgressData),
        fork(coursePageSaga.watchGetCoursePageChangeClassData),
        fork(coursePageSaga.watchGetCoursePageSelectedTabData),
        fork(coursePageSaga.watchGetCoursePageIncomingActivitiesData),
        fork(coursePageSaga.watchGetCoursePageAnnouncementsData),
        fork(coursePageSaga.watchGetCoursePageCurrentWeekActivitiesData),
        fork(coursePageSaga.watchGetCourseContentsWeeksData),
        fork(coursePageSaga.watchGetCourseContentsWeekActivitiesData),
        fork(coursePageSaga.watchGetCourseContentsActivityCardsData),
        fork(coursePageSaga.watchGetCourseClassActivityReportData),
        fork(coursePageSaga.watchGetClassActivityReportDownload),
        fork(coursePageSaga.watchGetDeleteDocumentActivityData),
        fork(coursePageSaga.watchGetSurveyChoicesData),
        fork(coursePageSaga.watchGetCourseContentMenuData),
        fork(coursePageSaga.watchGetActivityIdsByWeeksData),
        fork(coursePageSaga.watchGetCourseStudentListData),
        fork(coursePageSaga.watchGetCourseFilesData),
        fork(coursePageSaga.watchGetCourseAssignmentGradeInformation),
        fork(coursePageSaga.watchGetCourseAssignmentStudentList),
        fork(coursePageSaga.watchGetCourseAssignmentSaveGrade),
        fork(coursePageSaga.watchGetCourseAssignmentGradeDownloadAll),
        fork(coursePageSaga.watchGetCourseBulkGrade),
        fork(coursePageSaga.watchGetMyActivityStats),
        fork(coursePageSaga.watchGetActivityStatus),
        fork(coursePageSaga.watchUpdateInput),
        fork(coursePageSaga.watchGetProgressPercent),
        fork(coursePageSaga.watchGetActivityReportDetail),
        fork(coursePageSaga.watchSearchActivityCard),
        fork(coursePageSaga.watchClickWeekActivities),
        fork(coursePageSaga.watchSetCourseClassesData),
        fork(coursePageSaga.watchSetTriggerCourseStar),
        fork(coursePageSaga.watchSetTriggerRemovePrerequisite),
        
        fork(assignmentSaga.watchGetAddAssignmentData),
        fork(assignmentSaga.watchGetDeleteAssignmentData),
        fork(assignmentSaga.watchAddAssignementGetData),
        fork(assignmentSaga.watchSendAssignment),
        fork(assignmentSaga.watchGetAssignmentStudentLists),
        fork(assignmentSaga.watchGetMyAssigments),

        fork(documentSagas.watchGetAddDocumentData),
        fork(documentSagas.watchGetDeleteDocumentData),
        fork(documentSagas.watchUpdateDocumentData),
        fork(documentSagas.watchSaveDocumentPdfPage),

        fork(loginAnnouncementSaga.watchLoginAnnouncementData),
        fork(loginAnnouncementSaga.watchLoginAnnouncementDataById),

        fork(userHomeSagas.watchGetUserHomeCalendarActivitiesData),
        fork(userHomeSagas.watchGetUserHomeMyCoursesData),
        fork(userHomeSagas.watchGetUpcomingActivitiesData),

        fork(announcementSaga.AnnouncementSagas),

        fork(elessonSagas.ElessonSagas),

        fork(virtualClassSagas.watchGetAddVirtualClassData),
        fork(virtualClassSagas.watchGetDeleteVirtualClassData),
        fork(virtualClassSagas.watchUpdateVirtualClassData),
        fork(virtualClassSagas.watchJoinVirtualClassData),
        fork(virtualClassSagas.watchGetMyVirtualClass),
        fork(virtualClassSagas.watchRecalculateVirtualClassData),

        fork(linkSagas.watchGetAddLinkData),
        fork(linkSagas.watchGetDeleteLinkData),
        fork(linkSagas.watchUpdateLinkData),

        fork(messagesSagas.MessageSagas),

        fork(videoSagas.watchGetAddVideoData),
        fork(videoSagas.watchGetAddOrUpdateQuestionData),
        fork(videoSagas.watchGetVideoData),

        fork(profileSagas.ProfileSagas),
        fork(translationsSagas.TranslationSagas),
        fork(learningOutcomesSagas.LearningOutcomesSagas),
        fork(madlenIntegrationSagas.MadlenIntegrationSagas),
        fork(projectSagas.watchGetAddProjectData),
        fork(projectSagas.watchGetUpdateProjectData),
        fork(projectSagas.watchGetUserAddModalAllUsers),
        fork(projectSagas.watchAddGroup),
        fork(projectSagas.watchAutoAddGroup),
        fork(projectSagas.watchUpdateGroup),
        fork(projectSagas.watchFetchAllGroups),
        fork(projectSagas.watchAddUsersToGroup),
        fork(projectSagas.watchFetchUsersOfGroup),
        fork(projectSagas.watchGetDeleteProjectGroup),

        fork(forumSagas.ForumSagas),

        fork(reportSagas.ReportSagas),

        fork(backgroundSagas.BackgroundSagas),

        fork(notificationSagas.NotificationSagas),

        fork(examSagas.ExamSagas),
        
        fork(examSessionSagas.ExamSessionSagas),

        fork(calendarSagas.CalendarSagas),

        fork(questionSagas.QuestionSagas),
        fork(qrPollingSagas.QrPollingSagas),

        fork(ltiSagas.watchGetAddltiData),
        fork(ltiSagas.watchUpdateltiData),
        fork(ltiSagas.watchGetDeleteltiData),
        fork(ltiSagas.watchLaunchLti),

        fork(surveySagas.SurveySagas),

        fork(HelpdeskSagas.watchGetHelpDeskList),
        fork(HelpdeskSagas.watchGetHelpDeskMessage),
        fork(HelpdeskSagas.watchPostHelpDeskCreate),

        fork(activityCopySagas.watchGetActivityCopyDatas),
        fork(activityCopySagas.watchGetActivityCopyList),
        fork(activityCopySagas.watchGetStartActivityCopy),

        fork(activityMultiplySagas.ActivityMultiplySagas),

        fork(HelpdeskSagas.watchSetHelpDeskAssignedUser),
        fork(informationNoteSagas.InformationNoteSagas),
        
        fork(storageManagementSagas.StorageManagementSagas),

        fork(iFrameSagas.IFrameSagas),

        fork(gradebookSagas.GradebookSagas),

        fork(myFilesSagas.MyFilesSagas)
    ]);
}
